module.exports = __webpack_public_path__ + "img/fistbump.7c50e338.jpg";